module.exports = __webpack_public_path__ + "media/images/writer/home/icon-sound-69939312b372f3a65e2dad7720c15e89.svg";